<template>
  <div class="backTop-box" ref="backTop" style="top: 666px">
    <div
      :class='{"backTop-item": true, bor: isShowOfficialAccountsBtn}'
      @mouseover="isShowBuyListBar = true"
      @mouseleave="isShowBuyListBar = false"
    >
      <p class="buyListBar-desc--txt">已购列表</p>

      <BuyListBar class="buyListBar" v-show="isShowBuyListBar" />
    </div>

    <div
      class='backTop-item'
      @mouseover="isShowOfficialAccounts = true"
      @mouseleave="isShowOfficialAccounts = false"
      v-show = 'isShowOfficialAccountsBtn'
    >
      <p class="officialAccount-desc--txt">课堂官号</p>

      <OfficialAccounts
        v-show="isShowOfficialAccounts"
        class="officialAccounts"
        @update:show="isShowOfficialAccountsBtn = true"
      />
    </div>

    <div class='backTop-item' v-if="cooperationLink">
      <a :href="cooperationLink" target="_blank" @click="handleTeamWorkReport">
        <p class="officialAccount-desc--txt">
          合作申请
        </p>
      </a>
    </div>

    <div class="backTop-item" @click="goTop" v-if="isShowBackToTop">
      <div title="返回顶部" class="go-top icon">
        <i class = 'arrow-top backToTop'></i>
      </div>
    </div>
  </div>
</template>
<script>
import BuyListBar from './BuyListBar';
import OfficialAccounts from './OfficialAccounts';

export default {
    name: 'BackTopBar',
    components: {
        BuyListBar,
        OfficialAccounts
    },

    props: {
        visibilityHeight: {
            type: Number
        },
        cooperationLink: {
            type: String
        }
    },

    data() {
        return {
            isShowBuyListBar: false,
            isShowOfficialAccounts: false,
            isShowBackToTop: false,
            isShowOfficialAccountsBtn: false,
            backTop: 666,
            scrollHandler: null,
            timer: null
        };
    },

    mounted() {

        this.scrollToCompare('init');

        this.scrollHandler = this.scrollToCompare;

        document.addEventListener('scroll', this.scrollHandler, false);

    },

    destroyed() {
        document.removeEventListener('scroll', this.scrollHandler);
        clearTimeout(this.timer);
    },

    methods: {
        goTop() {
            const $el = document.querySelector('html');
            $el.scrollIntoView(true);
        },

        scrollToCompare(status) {
            const scrollTop = document.documentElement.scrollTop;

            if (status !== 'init') {
                if (this.backTop - scrollTop < 400) {
                    if (this.$refs.backTop.style.top !== '400px') this.$refs.backTop.style.top = 400 + 'px';
                } else {
                    this.$refs.backTop.style.top = this.backTop - scrollTop + 'px';
                }
            }

            if (document.documentElement.scrollTop > this.visibilityHeight) {

                if (!this.isShowBackToTop) this.isShowBackToTop = true;

            } else {
                if (this.isShowBackToTop) this.isShowBackToTop = false;
            }
        },

        handleTeamWorkReport () {
        }
    }
};
</script>
<style lang="less" scoped>
.backTop-box {
  position: fixed;
  left: 50%;
  // top: 703px;
  z-index: 999;
  border-radius: 4px;
  margin-left: 653px;
}

// .backTop-box>div:not(:first-child){
//     border-top: 1px solid #e5e9ef;
// }

.backTop-item {
  width: 54px;
  height: 54px;
  // overflow: hidden;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  background-color: #f4fafa;
  border: 1px solid #e7e7e7;

  &:first-child {
      border-radius: 4px;
  }

  &.bor {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  &:last-child {
      border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-bottom-right-radius: 4px;
  }

  &:nth-child(n + 2) {
    border-top: 0;
  }
  &::after {
    content: "";
    display: block;
    background: transparent;
    width: 10px;
    height: 55px;
    position: absolute;
    left: -10px;
    top: 0;
  }

  &:hover {
    // background-color: #F4FAFA;
    background: #0BA395;
    border: 1px solid #E7E7E7;
    .officialAccount-desc--txt,
    .buyListBar-desc--txt {
      color: #fff;
    }

    .arrow-top.backToTop {
        border-top: 2px solid #fff;
      border-right: 2px solid #fff;
    }

  }
}

.buyListBar {
  position: absolute;
  left: -350px;
  bottom: 0;
  z-index: 999;
}

.officialAccounts {
  position: absolute;
  left: -350px;
  bottom: 0;
}

.backTop-item .go-top {
  cursor: pointer;
  svg {
    transform: rotate(-90deg);
    #poly {
      fill: #c7cdd6;
    }
  }
}

.officialAccount-desc--txt,
.buyListBar-desc--txt {
    color: #0BA395;
  width: 32px;
  text-align: center;
}

.arrow-top.backToTop {
  position: relative;
  top: 5px;
  border-top: 3px solid #0ba395;
  border-right: 3px solid #0ba395;
}

@media screen and (max-width: 1438px) {
  .backTop-box {
    margin-left: 545px;
  }
}

</style>